import React from 'react';
import {useTranslation} from "react-i18next";
import {TourStep3} from "../../../../image";
import './FavoritesTeamNotes.scss'
import {Text} from "../../../index";

const FavoritesTeamNotes = () => {
    const {t} = useTranslation();

    return (
        <div className="step-video-hub">
            <img src={TourStep3} width={196} height={125}/>
            <Text size="f16" font="book" color="black">{t('tour_step_3_2_desc')}
            </Text>
        </div>
    );
};

export default FavoritesTeamNotes;